import { FlexBox, Page, Tabs, Text } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import { useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { appActions } from 'app/app.actions';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';

type SettingsChatbotsTabs = 'mim' | 'third-party';

const tabs = [
  { label: 'Mim chatbots', id: 'mim' },
  { label: 'Third party chatbots', id: 'third-party' },
];

export const SettingsChatbotsView = (): JSX.Element => {
  const hasIntegrationApiAccess = useHasAccess('settings.integration.api');
  const flags = useFeatureFlag([
    'ada-chat-channel',
    'digitalgenius-chat-channel',
    'kindly-chat-channel',
    'mim-chatbot',
  ]);
  const navigate = useAppNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const handleTabChange = (tab: string) => {
    navigate({ path: `/settings/chatbots/${tab as SettingsChatbotsTabs}` });
  };

  const handleSendFeedback = useCallback(() => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:feedbackForm',
          arg: {
            title: 'Chatbot Feedback',
            team: 'automation',
          },
        },
      }),
    );
  }, []);

  const selectedTab = location.pathname?.split('/').pop() ?? '';

  return (
    <Page>
      <Page.Head
        title={
          <FlexBox gap="200" alignItems="center">
            Chatbots
            <Text.ExternalLink onClick={handleSendFeedback} fontSize="200">
              Send feedback
            </Text.ExternalLink>
          </FlexBox>
        }
      />

      {hasIntegrationApiAccess &&
        (flags.adaChatChannel ||
          flags.digitalgeniusChatChannel ||
          flags.kindlyChatChannel) &&
        flags.mimChatbot && (
          <Page.Tabs>
            <Tabs
              tabs={tabs}
              selectedId={selectedTab}
              onChange={handleTabChange}
            />
          </Page.Tabs>
        )}

      <Page.Body>
        <Outlet />
      </Page.Body>
    </Page>
  );
};
